import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import CheckIcon from '@material-ui/icons/Check';
import { PROFFIT_SEARCH_LANDING_PAGE_BEFORE_AFTER_AFTER_IMAGE_URL } from '../../../../../define/consts/assets';
import SlideSearchTitleIcon from '../../../../Icon/Svg/SlideSearchTitleIcon';
import Image from '../../../Common/Image';
/**
 * PROFFIT SEARCHのへの登録モーダルの右側部分に表示するコンポーネント
 * @returns {JSX.Element}
 * @constructor
 */
const SlideSearchRegistrationModalRight = () => {
    const points = [
        '保有スライドのアップロード無制限',
        '資料検索・共有・保存の全機能利用可能',
        'PDF資料もPPT化して編集可能',
    ];
    return (_jsxs("div", Object.assign({ className: 'slide_search_registration_modal_right' }, { children: [_jsx(SlideSearchTitleIcon, { className: 'right_logo color' }), _jsxs("div", Object.assign({ className: 'right_inner' }, { children: [_jsx("div", Object.assign({ className: 'right_image' }, { children: _jsx(Image, { alt: '', className: 'image_thumbnail', src: PROFFIT_SEARCH_LANDING_PAGE_BEFORE_AFTER_AFTER_IMAGE_URL, useImage: true }) })), _jsx("ul", Object.assign({ className: 'right_points' }, { children: points.map((v) => (_jsxs("li", Object.assign({ className: 'point_item' }, { children: [_jsx(CheckIcon, { className: 'item_icon' }), _jsx("span", Object.assign({ className: 'item_text' }, { children: v }))] }), v))) }))] }))] })));
};
export default SlideSearchRegistrationModalRight;
